import { useSelector } from "react-redux";
import { Optional } from "../interfaces/Optional";
import { StoreState } from "../interfaces/storeState";

export const useOptional = (): Optional => useSelector(getOptional);

const getOptional = (state: StoreState): Optional => {
  if (!state.optional) {
    return {
      isMachineFixingsSelected: false,
      isTiltrotatorsSelected: false,
      isToolsSelected: false,
      machineFixingType: undefined,
      toolsProductTypes: undefined,
    };
  }

  return state.optional;
};
